/* eslint-disable */

import React, { useEffect, useState, useRef } from 'react';

import { ActionButton } from '../../base/premeeting';
import logger from '../logger';

type IWindowProps = {
  url: string;
  title: string;
  width: number;
  height: number;
};

type IPopupProps = IWindowProps & {
  onClose: () => void;
  onCode: (code: string, params: URLSearchParams) => void;
  children: React.ReactNode;
};

const createPopup = ({
    url, title, height, width
}: IWindowProps) => {
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;
    const externalPopup = window.open(
    url,
    title,
    `width=${width},height=${height},left=${left},top=${top}`,
    );

    return externalPopup;
};

const OauthPopup: React.FC<IPopupProps> = ({
    title = '',
    width = window.innerWidth,
    height = window.innerHeight,
    url,
    children,
    onCode,
    onClose
}: IPopupProps) => {
    const [ externalWindow, setExternalWindow ] = useState();
    const intervalRef = useRef();

    const clearTimer = () => {
        window.clearInterval(intervalRef.current);
    };

    /**
     * OnContainerClick.
     *
     * @returns {any}
     */
    function onContainerClick() {
        setExternalWindow(createPopup({
            url,
            title,
            width,
            height
        }));
    }

    useEffect(() => {
        if (externalWindow) {
            intervalRef.current = window.setInterval(() => {
                try {
                    const currentUrl = externalWindow.location.href;
                    const params = new URL(currentUrl).searchParams;
                    const code = params.get('mt') || params.get('access_token');
                    if (!code) {
                        return;
                    }
                    onCode(code, params);
                    clearTimer();
                    externalWindow.close();
                } catch (error) {
                    logger.log('errors are here', error);
                    // eslint-ignore-line
                } finally {
                    if (!externalWindow || externalWindow.closed) {
                        onClose();
                        clearTimer();
                    }
                }
            }, 700);
        }

        return () => {
            if (externalWindow) {
                externalWindow.close();
            }
            if (onClose) {
                onClose();
            }
        };
    }, [ externalWindow ]);

    return (
        <ActionButton
        // eslint-disable-next-line react/jsx-no-bind
            onClick = { onContainerClick }
            testId = 'prejoin.joinMeeting'
            type = 'meeth'>
            { children }
        </ActionButton>
    );
};

export default OauthPopup;
